export const generateRandomState = ()=> {
    const array = new Uint8Array(10); // for example, 10 bytes
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => byte.toString(16).padStart(2, '0')).join('');
}